<template>
  <div class="column_center_start shop_info_container">
    <div class="row_center_start shop_info_box">
      <text class="button-icon">location_on</text>
      <p style="color: #666666; margin: 0 10px 0 5px">地址</p>
      <p>{{ storeAddress }}</p>
    </div>
    <div class="row_center_start shop_info_box">
      <text class="button-icon">call</text>
      <p style="color: #666666; margin: 0 10px 0 5px">電話</p>
      <p>{{ tel }}</p>
    </div>
    <div class="row_start_start shop_business_hour">
      <text class="button-icon">schedule</text>
      <!-- <img src="@/assets/clock.png" /> -->
      <p class="font-semibold shrink-0 text-[#666666] mr-2.5 ml-1.5">營業時間</p>
      <div class="column_start_start w-full">
        <div class="mb-1.5" v-for="(day, index) in storeBusinessHour" :key="index">
          <div class="row_start_start w-full text-sm font-normal text-black">
            <div class="shrink-0 mr-3">{{ day.day }}</div>
            <div class="w-full column_start_start mb-1" v-if="day.hours.length">
              <div v-for="(businessHour, index) in day.hours" :key="index" class="row_center_start">
                <div>{{ businessHour }}</div>
              </div>
            </div>
            <div v-else class="mb-1">公休日</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    tel() {
      return this.$store.state.basic.storeInfo?.tel ?? '';
    },
    storeAddress() {
      return this.$store.state.basic.storeInfo?.address ?? '';
    },
    storeBusinessHour() {
      let ls = []
      const today = new Date().getDay();
      const mondayHours = this.mondayBusinessHours.map(item => `${item.startTime} - ${item.endTime}`);
      ls.push({ day: '星期一', hours: mondayHours, today: today === 1 });
      const tuesdayHours = this.tuesdayBusinessHours.map(item => `${item.startTime} - ${item.endTime}`);
      ls.push({ day: '星期二', hours: tuesdayHours, today: today === 2 });
      const wednesdayHours = this.wednesdayBusinessHours.map(item => `${item.startTime} - ${item.endTime}`);
      ls.push({ day: '星期三', hours: wednesdayHours, today: today === 3 });
      const thursdayHours = this.thursdayBusinessHours.map(item => `${item.startTime} - ${item.endTime}`);
      ls.push({ day: '星期四', hours: thursdayHours, today: today === 4 });
      const fridayHours = this.fridayBusinessHours.map(item => `${item.startTime} - ${item.endTime}`);
      ls.push({ day: '星期五', hours: fridayHours, today: today === 5 });
      const saturdayHours = this.saturdayBusinessHours.map(item => `${item.startTime} - ${item.endTime}`);
      ls.push({ day: '星期六', hours: saturdayHours, today: today === 6 });
      const sundayHours = this.sundayBusinessHours.map(item => `${item.startTime} - ${item.endTime}`);
      ls.push({ day: '星期日', hours: sundayHours, today: today === 0 });
      return ls;
    },
    sundayBusinessHours() {
      return this.$store.getters['basic/sundayBusinessHours'];
    },
    mondayBusinessHours() {
      return this.$store.getters['basic/mondayBusinessHours'];
    },
    tuesdayBusinessHours() {
      return this.$store.getters['basic/tuesdayBusinessHours'];
    },
    wednesdayBusinessHours() {
      return this.$store.getters['basic/wednesdayBusinessHours'];
    },
    thursdayBusinessHours() {
      return this.$store.getters['basic/thursdayBusinessHours'];
    },
    fridayBusinessHours() {
      return this.$store.getters['basic/fridayBusinessHours'];
    },
    saturdayBusinessHours() {
      return this.$store.getters['basic/saturdayBusinessHours'];
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.button-icon {
  font-size: 22px;
  color: #666666;
  width: 22px;
  height: 22px;
}

.shop_info_container {
  width: 92vw;
  margin: 10px auto 0;
  flex-shrink: 0;
  border-bottom: 1px solid #aaaaaa;

  h3 {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: bold;
    color: #000;
  }

  .shop_info_box {
    width: 100%;
    height: 40px;
    margin-top: 4px;
    border-bottom: 1px solid #aaaaaa;

    p {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 500;
      color: #fd5001;
    }

    img {
      width: 24px;
      height: 24px;
      margin: 0 0 0 2px;
    }
  }

  .shop_business_hour {
    width: 100%;
    min-height: 40px;
    margin-top: 10px;
    font-family: PingFang SC;
    font-size: 15px;
    letter-spacing: 0px;
    color: #666666;

    p {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 500;
      color: #666666;
    }

    img {
      width: 18px;
      height: 20px;
      margin: 0 0 0 2px;
    }
  }
}
</style>
